import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";

import { blogsClasses, StyledBlogs } from "./StyledBlog";

import { ViewContainer } from "../ViewContainer/ViewContainer";
import { Container } from "@mui/material";
import { Mode } from "../interfaces/mode";
import { useGA } from "../common/hooks";
import { blogs, getUniqueKeywords, getUniqueYearMonths } from "./blog-items";
import { IBlog } from "./IBlog";

// import { IBlog } from "./IBlog";
import { BlogHeader } from "./BlogHeader/BlogHeader";
import { BlogFilter } from "./BlogFilter/BlogFilter";
import { BlogGrid } from "./BlogGrid/BlogGrid";

// Convert URL keyword format back to original keyword format
const formatKeywordForUrl = (keywordValue: string): string => {
    return keywordValue.toLowerCase().replace(/[^a-z0-9]+/g, '-');
};

export const Blogs = () => {
    useGA("Blogs");
    const { keyword: urlKeyword, date: urlDate } = useParams();
    const [innerBlogs, setBlogs] = useState(blogs);
    const yearMonths = getUniqueYearMonths();
    const keywords = getUniqueKeywords();

    const findKeywordFromUrl = (urlKeywordParam: string | undefined): string => {
        if (!urlKeywordParam || urlKeywordParam === "any") {
            return "all";
        }
        // Find the original keyword that matches the URL format
        const matchedKeyword = keywords.find(
            (kw) => formatKeywordForUrl(kw) === urlKeywordParam
        );
        return matchedKeyword || "all";
    };

    // Convert year-month from URL - use directly if it exists in yearMonths
    const findDateFromYearMonth = (yearMonth: string | undefined): string => {
        if (!yearMonth || yearMonth === "any") {
            return "all";
        }
        // Check if the year-month exists in our list
        return yearMonths.includes(yearMonth) ? yearMonth : "all";
    };

    const initialKeyword = findKeywordFromUrl(urlKeyword);
    const initialDate = findDateFromYearMonth(urlDate);

    // Filter blogs based on URL parameters
    const urlChanged = useCallback(() => {
        let blogList = [...blogs];

        // Filter by keyword
        if (urlKeyword && urlKeyword !== "any") {
            blogList = blogList.filter((blog: IBlog) => {
                return blog.keywords.some(
                    (kw) => formatKeywordForUrl(kw) === urlKeyword
                );
            });
        }

        // Filter by year-month
        if (urlDate && urlDate !== "any") {
            blogList = blogList.filter((blog: IBlog) => {
                const dateObj = new Date(blog.publishedDate);
                const year = dateObj.getFullYear();
                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                return `${year}-${month}` === urlDate;
            });
        }

        setBlogs(blogList);
    }, [urlKeyword, urlDate]);

    useEffect(() => {
        urlChanged();
    }, [urlKeyword, urlDate, urlChanged]);

    return <ViewContainer mode={Mode.Dark}>
        <StyledBlogs className={blogsClasses.root}>
            <BlogHeader />

            <Container maxWidth={"lg"}>
                {/* <BlogFilter 
                    yearMonths={yearMonths}
                    keywords={keywords}
                    keyword={initialKeyword}
                    date={initialDate}
                /> */}

                <BlogGrid blogs={innerBlogs} />
            </Container>
        </StyledBlogs>
    </ViewContainer>;
};
